<template>
    <div>
        <!-- <div class="loft-main" v-for="items in list" :key="items">
            <div class="main-img">
                <img :src="items.image_url" style="height: 255px" alt="">
            </div>
            <div class="loft-wrap">
                <template v-for="(item, index) in items.child">    
                    <div class="loft-wrap-item" v-if="index < 4" :key="item.id">
                        <img :src="item.image_url" alt="">
                    </div>
                </template>

                
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
    data() {
        return {
            list: []
        }
    },
    created() {
        this.init()
    },
    methods: {
        init() {
            this.$api.categories().then(res => {
                if(res.status) {
                    console.log('res', res.data.splice(0, 4))
                    this.list = res.data.splice(0, 4)
                }
            })
        }
        
    }

}
</script>


<style lang="scss" scoped>
.loft-main {
    width: 1226px;
    cursor: pointer;
    .main-img {
        img {
            width: 100%;
        }
    }
    .loft-wrap {
        &-item{
            img {
             width: 100%;
            }
        }
    }
}
</style>
